/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";
import { updateEmailRequestSchema } from "./updateEmailRequestSchema.ts";

export const userUpdateEmailCreateStatus200Schema = z.any();

export const userUpdateEmailCreateStatus400Schema = errorResponseSchema;

export const userUpdateEmailCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userUpdateEmailCreateResponseSchema = z.union([
	userUpdateEmailCreateStatus200Schema,
	userUpdateEmailCreateStatus400Schema,
	userUpdateEmailCreateStatus401Schema,
]);

export const userUpdateEmailCreateDataSchemaJson = updateEmailRequestSchema.describe("Сериализатор обновления email.");

export const userUpdateEmailCreateDataSchemaXml = updateEmailRequestSchema.describe("Сериализатор обновления email.");

export const userUpdateEmailCreateDataSchema = z.union([userUpdateEmailCreateDataSchemaJson, userUpdateEmailCreateDataSchemaXml]);
